import { PartnerResponseModel } from "./../partner/PartnerResponseModel";
/*
Model defined for Maintaining Login/User Responses. It can also be used for transferring model
*/

import {
    PermissionsModel,
    uiPermissionsModel,
    RoleResponseModel,
    BranchResponseModel,
} from "../index";

export class LoginResponseModel {
    id: string;
    email: string;
    firstName: string;
    forceChangePassword: boolean;
    lastName: string;
    mobile: string;
    photo: string;
    pinCode: string;
    roles: any;
    permissions: PermissionsModel[];
    uiPermissions: uiPermissionsModel[];
    notificationMessageResponses: notificationMessageResponsesModel;
    branchId: string;
    branch: BranchResponseModel;
    emailVerified: string;
    partner: PartnerResponseModel;
    address: string;
    cpdUiPermissions: any;
    city: string;
    password: string;
    country: string;
    registered: string;
    timeOutInSeconds: string;
    tourOperatorReferrer: boolean;
}
export class notificationMessageResponsesModel {
    message: string;
    notificationPriority: string;
    title: string;
}
export class PartnerMobileRequest {
    mobile: string;
    pan: string;
}

export class PartnerOtpValidateRequest {
    mobile: string;
    otp: string;
}

export class PartnerOnBoardRequest {
    firstName: string;
    lastName: string;
    pan: string;
    partnerName: string;
    email: string;
    mobile: string;
    branchId: string;
}
export class ResendOTP {
    mobile: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/login/LoginResponseModel.ts